import { useApi } from "@api/ApiProvider";
import { Document } from "@components/documents/types";
import { useSessions } from "@hooks/useSessions";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { listFilesApi } from "./documents.api";
import { documentsQueryKeyBySession } from "./utils";

export const useDocumentsQuery = (): UseQueryResult<Document[], Error> => {
  const { api } = useApi();
  const { sessionId } = useSessions();

  return useQuery({
    queryKey: documentsQueryKeyBySession(sessionId),
    queryFn: () => listFilesApi(api, sessionId!),
    enabled: !!sessionId,
  });
};
